import React from 'react';
import { BadgeCheck, Star } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-white" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-14">
          <div className="relative" data-id="element-15">
            <div className="aspect-square rounded-3xl overflow-hidden" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/oAWe8GwN5jE8vqQSZkph3N/star-0lRNxeYfk-M-unsplash.jpg" alt="Arizona backyard pool at dusk" className="w-full h-full object-cover" data-id="element-17" />
            </div>
            <div className="absolute -bottom-8 -right-8 bg-blue-600 text-white p-8 rounded-3xl shadow-xl hidden md:block max-w-xs" data-id="element-18">
              <BadgeCheck className="w-10 h-10 mb-4 text-blue-200" data-id="element-19" />
              <p className="font-bold text-xl mb-1" data-id="element-20">Local Experts</p>
              <p className="text-blue-100 text-sm" data-id="element-21">
                Serving Gilbert & the East Valley with pride.
              </p>
            </div>
          </div>

          <div data-id="element-22">
            <h2 className="text-blue-600 font-bold tracking-wide uppercase text-sm mb-3" data-id="element-23">
              About Crystal Water Pool & Spa Service
            </h2>
            <h3 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-6" data-id="element-24">
              Growing to serve you better.
            </h3>
            <div className="space-y-6 text-lg text-slate-600 leading-relaxed" data-id="element-25">
              <p data-id="element-26">
                Crystal Water Pool & Spa Service was built on a foundation of
                hard work, honest pricing, and doing the job right the first
                time. For years, we've been the go-to experts for both routine
                maintenance and complex pool repairs in the Gilbert area.
              </p>
              <p data-id="element-27">
                <strong data-id="element-28">Recently, we hit an exciting milestone:</strong> we
                hired our first dedicated route employee!
              </p>
              <p data-id="element-29">
                What does this mean for you? It means we now have dedicated
                manpower solely focused on keeping your pool sparkling clean
                week after week. It also frees up our senior ownership to focus
                entirely on what they do best: tackling those challenging,
                high-ticket repairs, equipment upgrades, and custom tile
                restorations.
              </p>
              <p className="font-medium text-slate-900" data-id="element-30">
                Better weekly service. Faster repair response times. That's the
                Crystal Water Pool & Spa Service promise.
              </p>
            </div>
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-31">
          {[{
          name: 'Sarah M.',
          loc: 'Gilbert, AZ',
          text: 'Finally found a pool service that actually shows up on the same day every week. The water has never looked better.'
        }, {
          name: 'David T.',
          loc: 'Chandler, AZ',
          text: "They fixed a pump issue that two other companies couldn't figure out. Honest guys, fair prices. Highly recommend getting on their route."
        }, {
          name: 'Jennifer L.',
          loc: 'Mesa, AZ',
          text: 'The calcium buildup on our tile was awful. Crystal Water Pool & Spa Service blasted it away and it looks brand new. Now they maintain it weekly.'
        }].map((review, idx) => <div key={idx} className="bg-slate-50 p-8 rounded-3xl border border-slate-100" data-id="element-32">
              <div className="flex gap-1 mb-4" data-id="element-33">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-34" />)}
              </div>
              <p className="text-slate-700 mb-6 italic" data-id="element-35">"{review.text}"</p>
              <div data-id="element-36">
                <p className="font-bold text-slate-900" data-id="element-37">{review.name}</p>
                <p className="text-sm text-slate-500" data-id="element-38">{review.loc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}